module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-134.f02909ad.svg";